import { create } from 'zustand'

/** How long a request waits for its page to load and register the action before it is dropped. */
export const PENDING_PAGE_ACTION_TTL_MS = 15_000

export interface PendingPageAction {
	/** The page the action belongs to. It only runs there, never on a page that reuses the id. */
	pathname: string
	actionId: string
	/** A split button's child action, e.g. creating a stream from a template. */
	childId?: string
	expiresAt: number
}

interface PendingPageActionState {
	pending: PendingPageAction | null
	request: (action: Omit<PendingPageAction, 'expiresAt'>) => void
	clear: () => void
}

/**
 * A header action to run once its page has loaded. The palette sets it and navigates; the runner fires
 * the page's own handler when the page registers that action, so a create command reuses the exact
 * flow the page's button runs.
 */
export const usePendingPageActionStore = create<PendingPageActionState>()(set => ({
	pending: null,
	request: action => set({ pending: { ...action, expiresAt: Date.now() + PENDING_PAGE_ACTION_TTL_MS } }),
	clear: () => set({ pending: null }),
}))
